import apiClient from '@/axios';

export const login = async (email, password) => {
  return apiClient.post('/login-email', { email, password });
};

export const logout = () => {
  localStorage.removeItem('token');
  sessionStorage.clear();
};